export enum VoucherCampaignType {
    REFERRAL_PROGRAM = 'REFERRAL_PROGRAM',
    DISCOUNT_COUPONS = 'DISCOUNT_COUPONS',
    PROMOTION = 'PROMOTION',
    GIFT_VOUCHERS = 'GIFT_VOUCHERS',
}
